import { createContext, useState } from "react";

export const ExpenseContext = createContext();

const ExpenseProvider = ({ children }) => {
  const [savedExpenseSession, setExpenseSession] = useState({});

  const values = { savedExpenseSession, setExpenseSession };

  return (
    <ExpenseContext.Provider value={values}>{children}</ExpenseContext.Provider>
  );
};

export default ExpenseProvider;
